<div class="list-page kapea" style="max-width: 1200px">
  <div class="ylaosan-kontrollit">
    <button type="button" class="etsi-nappi" (click)="avaaHaku()" aria-haspopup="dialog" [attr.aria-label]="'tuotteet.haku.avaa-haku' | translate | async">
      <mat-icon>search</mat-icon>
      <span>{{ 'tuotteet.etsi' | translate | async }}</span>
    </button>
    <div class="lisaa-nappula-container">
      <button mat-button (click)="lisaa()" type="button" class="primarybutton mat-elevation-z4">
        <mat-icon>add</mat-icon>
        {{ 'tuotteet.lisaa' | translate | async }}
      </button>
    </div>
  </div>

  <div style="margin: 3em">
    {{ 'tuotteet.vihje' | translate | async }}
  </div>

  <div style="position: relative">
    <mat-table matSort [dataSource]="naytettavatTuotteetObservable | async" [matSortDisableClear]="true" style="min-height: 94px">
      <!-- Column Definition: Nimi -->
      <ng-container matColumnDef="nimi">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tuotteet.nimi' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.nimi }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="yksikko">
        <mat-header-cell *matHeaderCellDef fxFlex="70px"> {{ 'tuotteet.yksikko' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="70px"> {{ row.yksikko || '–' }} </mat-cell>
      </ng-container>

      <!-- Column Definition: Hinta -->
      <ng-container matColumnDef="hinta">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="130px"> {{ 'tuotteet.hinta-veroton' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="130px"> {{ row.hinta | lmoney: row.valuutta | async }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="hintaVerollinen">
        <mat-header-cell *matHeaderCellDef fxFlex="130px"> {{ 'tuotteet.hinta-verollinen' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="130px">
          @if (row.hintaVerollinen !== null) {
            {{ row.hintaVerollinen | lmoney: row.valuutta | async }}
          } @else {
            –
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="alv">
        <mat-header-cell *matHeaderCellDef fxFlex="70px"> {{ 'tuotteet.alv' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="70px">
          @if (row.alvProsentti !== null) {
            {{ row.alvProsentti | ldecimal: 2 | async }} %
          } @else {
            –
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="propertiesToDisplay"></mat-header-row>
      <mat-row (click)="muokkaa(row)" *matRowDef="let row; columns: propertiesToDisplay"></mat-row>
    </mat-table>
    @if (naytaEiYhtaanObservable | async) {
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
        <div style="width: 100%; padding-top: 40px; text-align: center">
          {{ 'tuotteet.rekisteri-tyhja' | translate | async }}
          <div>{{ 'tuotteet.rekisteri-tyhja-vihje' | translate | async }}</div>
        </div>
      </div>
    }
    <div lemon-loading [show]="lataaObservable | async"></div>
  </div>

  <mat-paginator #paginator [length]="dataSource?.rivienMaaraObservable | async" [pageSize]="dataSource?.getPage().pageSize" [pageIndex]="dataSource?.getPage().pageIndex" [pageSizeOptions]="[20, 50, 200]"> </mat-paginator>
</div>
<app-tuoterekisteri-haku [avoinna]="hakuAvoinna" (suljettu)="suljeHaku()"></app-tuoterekisteri-haku>
